export class Unternehmen {
  id: number = 0;
  titel: string = '';
  realm: string = '';

  archivApiUrl: string = '';
  archivApiKey: string = '';

  createdAt: Date = new Date();
  updatedAt: Date = new Date();

  hasIdpRealm: boolean = false;
}
